const WhatsAppChatIcon = ({ ...props }) => (
  <svg viewBox='0 0 24 24' {...props}>
    <path
      d='M6 8a5 5 0 0 0 12 0M3 20l5-2 3 2 3-2 5 2'
      stroke='currentColor'
      strokeWidth='1.4'
      fill='none'
    />
  </svg>
);

export default WhatsAppChatIcon;
